import { render } from "./roleadmin.vue?vue&type=template&id=9ed6848e&scoped=true&ts=true"
import script from "./roleadmin.vue?vue&type=script&lang=ts"
export * from "./roleadmin.vue?vue&type=script&lang=ts"

import "./roleadmin.vue?vue&type=style&index=0&id=9ed6848e&lang=scss&scoped=true"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ed6848e"]])

export default __exports__